import { setCardElementFlowEnabled } from 'actions/ui/ui';
import { FF_CARD_ELEMENT_FLOW } from 'constants/features';
import { CHECKOUT_PLATFORM } from 'constants/ui';
import { useExperimentFlag } from 'hooks/useExperiments/useExperimentFlag';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  getSenderCountry,
  getSenderCurrency,
} from 'selectors/entities/order/order';
import {
  getRecipientCountryCode,
  getRecipientCurrencyCode,
  getRecipientId,
} from 'selectors/entities/recipient/recipient';
import { getSelectedOffer } from 'selectors/ui/ui';
import { useDispatch } from 'store/configureStore';

export const useCardElementFlowExperiment = () => {
  const dispatch = useDispatch();
  const countryFrom = useSelector(getSenderCountry);
  const countryTo = useSelector(getRecipientCountryCode);
  const senderCurrency = useSelector(getSenderCurrency);
  const currencyFrom = senderCurrency?.code ?? '';
  const currencyTo = useSelector(getRecipientCurrencyCode);
  const offer = useSelector(getSelectedOffer);
  const recipientId = useSelector(getRecipientId);

  const hasRequiredContext =
    !!countryFrom && !!countryTo && !!offer?.paymentOption && !!recipientId;

  const { value: isCardElementFlowEnabled, isFetched } = useExperimentFlag(
    {
      flagName: FF_CARD_ELEMENT_FLOW,
      userContext: {
        country_from: countryFrom ?? '',
        country_to: countryTo ?? '',
        currency_from: currencyFrom,
        currency_to: currencyTo ?? '',
        payment_option: offer?.paymentOption ?? '',
        portal_code: recipientId,
        platform: CHECKOUT_PLATFORM,
      },
    },
    { enabled: hasRequiredContext },
  );

  useEffect(() => {
    if (isFetched) {
      dispatch(setCardElementFlowEnabled(isCardElementFlowEnabled));
    }
  }, [isFetched, isCardElementFlowEnabled, dispatch]);
};
